import SafeArea from "components/safearea";
import * as React from "react";
import styled from "styled-components";
import { H3, ImageCon, P } from "../../style";
import Handyman from "images/handyman.jpg";
import { Button, SubtleButton } from "components/button";
import useWindowDimensions from "hooks/useWindowDimensions";
import ContactSales from "../../components/contactSalesButton";
import { useTranslation } from 'react-i18next';

export default function LearnMoreSection() {
  const { t } = useTranslation();
  const tBase = "pages.unprotected.home.container.section.manageRequest";
  const tr = (key) => t(`${tBase}.${key}`);

  const { width } = useWindowDimensions();
  return (
    <Con>
      <SSafeArea padding flex="row">
        {width > 1300 ? (
          <>
            <div>
              <H3>{tr("End-to-end integration")}</H3>
              <P>
                {tr("Manage incoming requests by from your own customizable EServ pro website.")}
                <br />
                <br />
                {tr("From sending a quote to receiving payments from the customer, we have got you covered so you can focus on what providing the best Services to your customers.")}
              </P>
              <ContactSales />
            </div>
            <SImageCon>
              <img src={Handyman} />
            </SImageCon>
          </>
        ) : (
          <>
            <SImageCon>
              <img src={Handyman} />
            </SImageCon>
            <div>
              <H3>{tr("End-to-end integration")}</H3>
              <P>
                {tr("Manage incoming requests by from your own customizable EServ pro website.")}
                <br />
                <br />
                {tr("From sending a quote to receiving payments from the customer, we have got you covered so you can focus on what providing the best Services to your customers.")}
              </P>
              <ContactSales />
            </div>
          </>
        )}
      </SSafeArea>
    </Con>
  );
}

const SImageCon = styled(ImageCon)`
  > img {
    object-fit: cover;
    width: 100%;
  }
`;

const Con = styled.div`
  display: flex;
`;

const SSafeArea = styled(SafeArea)`
  display: flex;
  justify-content: center;
  align-items: center;
  > div:first-child {
    flex: 0 0 40%;
    margin: 1rem;
  }
  @media screen and (max-width: 1300px) {
    flex-direction: column;
    > div:first-child {
      margin: 0;
      flex: 1;
    }
  }
`;
